import { useQuery } from "@tanstack/react-query"
import { authEmployeeQuery } from "../lib/authEmployeeQuery"

export function useAuthEmployeeQuery() {
  return useQuery(authEmployeeQuery())
}
